<template>
    <li class="item">
        <div class="item__title">
            {{dateParser(exec.order_date)}}
            <span class="number">{{exec.order_num}}</span>
            <span class="status">{{exec.status | getStatus}}</span>
        </div>
        <div class="item_sum">
            <b>Сумма:</b>
            <span v-if="exec.sum">{{moneyFormat(exec.sum, 2)}} <i class="uk-icon-rub"></i></span>
            <span v-else>-</span>
        </div>
        <div v-if="exec.order_object" class="item__object">
            <b>Предмет исполнения:</b>
            <span>{{exec.order_object}}</span>
        </div>
        <div v-if="exec.document_date" class="item__date">
            <b>Дата исполнительного документа:</b>
            <span>{{dateParser(exec.document_date)}}</span>
        </div>
        <div v-if="exec.document_num" class="item__number">
            <b>№ исполнительного документа:</b>
            <span>{{exec.document_num}}</span>
        </div>
        <div v-if="exec.dep_address" class="item__address">
            <b>Адрес отдела судебных приставов:</b>
            <span>{{exec.dep_address}}</span>
        </div>
        <div v-if="exec.end_reason" class="item__end">
            <b>Основание окончания:</b>
            <span class="law" :title="getReasonText(exec.end_reason)">{{exec.end_reason | getReasonArticle}}</span>
            (на {{dateParser(exec.end_date)}})
        </div>
    </li>
</template>

<script>
export default {
    props: {
        exec: Object
    },
    data: () => ({
        reasonsText: {
            46: {
                1: {
                    3: 'Невозможно установить местонахождение должника, его имущества либо получить сведения о наличии принадлежащих ему денежных средств и иных ценностей, находящихся на счетах, во вкладах или на хранении в банках или иных кредитных организациях, за исключением случаев, когда настоящим Федеральным законом предусмотрен розыск должника или его имущества.',
                    4: 'У должника отсутствует имущество, на которое может быть обращено взыскание, и все принятые судебным приставом-исполнителем допустимые законом меры по отысканию его имущества оказались безрезультатными.',
                }
            },
            47: {
                1: {
                    6: 'Ликвидация должника-организации и направление исполнительного документа в ликвидационную комиссию (ликвидатору), за исключением исполнительных документов, указанных в части 4 статьи 96 настоящего Федерального закона.',
                    7: 'Признание должника банкротом и направление исполнительного документа арбитражному управляющему, за исключением исполнительных документов, указанных в части 4 статьи 69.1 и части 4 статьи 96 настоящего Федерального закона.'
                }
            }
        }
    }),
    methods: {
        getReasonText(reason) {
            reason = typeof reason === 'string' ? JSON.parse(reason) : reason
            return this.reasonsText?.[Number(reason.article)]?.[Number(reason.part)]?.[Number(reason.sub_part)] || ''
        }
    },
    filters: {
        getStatus(status) { return status === 'opened' ? 'Открыто' : 'Окончено' },
        getReasonArticle(reason) {
            reason = typeof reason === 'string' ? JSON.parse(reason) : reason
            return ` 229-ФЗ ст. ${reason.article} п. ${reason.part} п.п. ${reason.sub_part}`
        }
    }
}
</script>

<style lang="sass" scoped>
.item
    font-size: 14px
    color: #444
    display: flex
    flex-direction: column
    gap: 6px
    padding: 15px 0
    &:not(:last-child)
        border-bottom: 1px solid #ddd
    &__title
        font-size: 20px
        .number
            color: #3498db
        .status
            font-size: 14px
            font-weight: bold
            margin-left: 20px
    &__end
        .law
            cursor: help
            border-bottom: 1px dashed #c7c6c6
</style>